/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PageWidgetDetail } from '../../models/page-widget-detail';

export interface GetApiWidgetOperations$Params {
  arid?: number;
}

export function getApiWidgetOperations(http: HttpClient, rootUrl: string, params?: GetApiWidgetOperations$Params, context?: HttpContext): Observable<StrictHttpResponse<PageWidgetDetail>> {
  const rb = new RequestBuilder(rootUrl, getApiWidgetOperations.PATH, 'get');
  if (params) {
    rb.query('arid', params.arid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PageWidgetDetail>;
    })
  );
}

getApiWidgetOperations.PATH = '/api/AclRole/getApiWidgetOperations';
